export default "__VITE_ASSET__1b98cb34__"